import axios from "axios";
import { API_URL } from "constants";

export const addSigner = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/dokobit/add-signer`;
  return axios.post(url, payload).then((response) => response.data);
};

export const removeSigner = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/dokobit/remove-signer`;
  return axios.post(url, payload).then((response) => response.data);
};

export const fetchSignUrl = async (companyId, fileId) => {
  const url = `${API_URL}/${companyId}/dokobit/fetch-sign-url/file/${fileId}`;
  return axios.get(url).then((response) => response.data);
};

export const declineDokobitSignRequest = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/dokobit/decline-sign-request`;
  return axios.post(url, payload).then((response) => response.data);
};
